<template>
  <TranslucentCard class="translucent-card" :class="{'translucent-card-width': !isMenuMiniSize, 'translucent-card-thin-menu-width': isMenuMiniSize}" :isErrorFooter="isErrorFooter">
    <p class="error-num-message" v-if="!isErrorFooter">
      <i class="mdi mdi-alert-circle"></i> 
      パーツ内容：{{errorList.length}}件についてご確認ください。
    </p>
    <div class="icon-wrapper">
      <MinusIcon v-if="isErrorFooter" @click.native="changeIsErrorFooter(false)"/>
      <PlusIcon v-if="!isErrorFooter" @click.native="changeIsErrorFooter(true)" />
    </div>
    <template v-if="isErrorFooter">
      <div class="arrow-circle-wrapper">
        <LeftArrowCircle @click.native="minusErrorItemNumber(-1)" />
      </div>
      <ScenarioErrorFooterContents :errorItemNumber="errorItemNumber" :errorList="errorList"/>
      <div class="arrow-circle-wrapper">
        <RightArrowCircle @click.native="plusErrorItemNumber(1)" />
      </div>
    </template>
  </TranslucentCard>
</template>

<script>
import TranslucentCard from '@/components/atoms/chatbot/cards/TranslucentCard'
import MinusIcon from '@/components/atoms/chatbot/icons/MinusIcon'
import PlusIcon from '@/components/atoms/chatbot/icons/PlusIcon'
import LeftArrowCircle from '@/components/atoms/chatbot/icons/LeftArrowCircle'
import RightArrowCircle from '@/components/atoms/chatbot/icons/RightArrowCircle'
import ScenarioErrorFooterContents from '@/components/molecules/chatbot/footers/ScenarioErrorFooterContents'

export default {
  components: {
    TranslucentCard,
    MinusIcon,
    PlusIcon,
    LeftArrowCircle,
    RightArrowCircle,
    ScenarioErrorFooterContents
  },
  props: {
    isErrorFooter: {
      type: Boolean,
      require: false
    },
    errorItemNumber: {
      type: Number,
      require: false
    },
    errorList: {
      type: Array,
      require: false
    },
    isMenuMiniSize: {
      type: Boolean,
      default: false,
      require: true
    }
  },
  methods: {
    changeIsErrorFooter (bool) {
      this.$emit('change-is-error-footer', bool)
    },
    minusErrorItemNumber (i) {
      this.$emit('minus-error-item-number', i)
    },
    plusErrorItemNumber (i) {
      this.$emit('plus-error-item-number', i)
    }
  },
}
</script>

<style lang="scss" scoped>
.translucent-card-width {
  width: calc(100% - 685px);
}
.translucent-card-thin-menu-width {
  width: calc(100% - 533px);
}
.translucent-card {
  .error-num-message {
    font-size: 14px;
  }
  .icon-wrapper {
    position: absolute;
    top: 0px;
    right: 16px;
  }
  .arrow-circle-wrapper {
    display: flex;
    align-items: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/chatbot/footers/ScenarioErrorFooter.vue